import yup from '../../../config/yup';

export const refreshValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('refresh'),
  action: yup.string().default('REFRESH').required('Action is required'),
  command: yup
    .string()
    .default('REFRESH')
    .required('Command is required')
    .matches(/^REFRESH\s+\S+/i, "Command must start with 'REFRESH' followed by at least one word"),
});
